const ButtonType = {
  ADD: 'Add',
  EDIT: 'Edit',
  DELETE: 'Delete'
}

export default ButtonType
